export const buildLostInviteActionHref = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  return path.startsWith('/') ? path : `/${path}`;
};

export const openLostInviteActionLink = (path) => {
  const href = buildLostInviteActionHref(path);
  if (!href) return;
  window.open(href, '_blank', 'noopener,noreferrer');
};
